module.exports = __webpack_public_path__ + "2b4d906162994c0f8ca7acdd76e88539.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/necklace-pearls.png
// module id = 1326
// module chunks = 0